theme.headerSection = (function () {
  function header() {
    /* Mobile Menu Function */
    const offcanvasHeader = function () {
      const offcanvasOpen = document.querySelector(
          ".header__actions_btn--menu"
        ),
        offcanvasClose = document.querySelector(".offcanvas__close_btn"),
        offcanvasHeader = document.querySelector(".offcanvas-header"),
        offcanvasMenu = document.querySelectorAll(".offcanvas__menu"),
        body = document.querySelector("body");

      /* Add a Button For SubMenu Toggle - PREVENT DUPLICATES AND FIX POSITIONING */
      offcanvasMenu.forEach((item) => {
        item
        .querySelectorAll(".offcanvas__sub_menu")
        .forEach(function (ul) {
          const parentLi = ul.parentNode;
          const menuItemLink = parentLi.querySelector('.offcanvas__menu_item[data-has-submenu]');
          
          // Remove any existing toggle buttons more thoroughly
          parentLi.querySelectorAll(".offcanvas__sub_menu_toggle").forEach(toggle => toggle.remove());
          
          // Add toggle button to the menu item link, not the li container
          if (menuItemLink) {
            const subMenuToggle = document.createElement("button");
            subMenuToggle.classList.add("offcanvas__sub_menu_toggle");
            subMenuToggle.setAttribute("aria-label", "menu collapse");
            subMenuToggle.innerHTML = "+"; // Add the + content
            menuItemLink.appendChild(subMenuToggle); // Append to the link, not the li
          }
        });
      });
      
      /* Open/Close Menu On Click Toggle Button */
      offcanvasOpen.addEventListener("click", function (e) {
        e.preventDefault();
        offcanvasHeader.classList.add("open");
        body.style.overflowY = "hidden";
        
        // Add enhanced features after menu opens
        setTimeout(function() {
          addClickableHeaders();
          autoExpandCardsMenu();
        }, 100);
      });
      
      offcanvasClose.addEventListener("click", function (e) {
        e.preventDefault();
        offcanvasHeader.classList.remove("open");
        body.style.overflowY = null;
      });
      
      /* Open/Close Sub Menu On Click Toggle Button */
      offcanvasMenu.forEach((offcanvasMenuitem) => {
        offcanvasMenuitem
        .querySelectorAll(".offcanvas__sub_menu_toggle")
        .forEach(function (toggle) {
          toggle.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation(); // Prevent triggering the menu item click
            
            const menuItem = this.closest('.offcanvas__menu_item'); // Find the menu item
            const parent = menuItem.closest('.offcanvas__menu_li'); // Find the li parent
            const submenu = parent.querySelector('.offcanvas__sub_menu'); // Find the submenu
            
            if (parent.classList.contains("active")) {
              this.classList.remove("active");
              parent.classList.remove("active");
              this.innerHTML = "+"; // Change back to plus
              if (submenu) {
                // Remove auto-opened class to enable transitions for manual closing
                submenu.classList.remove("auto-opened");
                slideUp(submenu);
              }
            } else {
              this.classList.add("active");
              parent.classList.add("active");
              this.innerHTML = "−"; // Back to Unicode minus
              if (submenu) {
                // Remove auto-opened class to enable transitions for manual opening
                submenu.classList.remove("auto-opened");
                slideDown(submenu);
              }
              
              // Reset other toggle buttons to plus
              getSiblings(parent).forEach(function (item) {
                item.classList.remove("active");
                const otherSubmenu = item.querySelector('.offcanvas__sub_menu');
                if (otherSubmenu) {
                  otherSubmenu.classList.remove("auto-opened"); // Remove auto-opened class
                  slideUp(otherSubmenu);
                }
                // Find toggle buttons inside menu items in siblings
                const otherToggles = item.querySelectorAll('.offcanvas__menu_item .offcanvas__sub_menu_toggle');
                otherToggles.forEach(function(otherToggle) {
                  otherToggle.innerHTML = "+";
                  otherToggle.classList.remove("active");
                });
              });
            }
          });
        });                   
      });

      document.addEventListener("click", function (event) {
        if (
          !event.target.closest(".header__actions_btn--menu") &&
          !event.target.classList.contains(
            ".header__actions_btn--menu".replace(/\./, "")
          )
        ) {
          if (
            !event.target.closest(".offcanvas-header") &&
            !event.target.classList.contains(
              ".offcanvas-header".replace(/\./, "")
            )
          ) {
            offcanvasHeader.classList.remove("open");
            body.style.overflowY = null;
          }
        }
      });

      /* Remove Mobile Menu Open Class & Hide Mobile Menu When Window Width in More Than 991 */
      window.addEventListener("resize", function () {
        if (window.outerWidth >= 992) {
          offcanvasHeader.classList.remove("open");
          body.style.overflowY = null;
        }
      });
      
      // Enhanced Features Functions
      function addClickableHeaders() {
        const menuItems = document.querySelectorAll('.offcanvas__menu_item[data-has-submenu]');
        
        menuItems.forEach(menuItem => {
          const parentLi = menuItem.closest('.offcanvas__menu_li');
          const toggle = menuItem.querySelector('.offcanvas__sub_menu_toggle'); // Toggle is now inside menuItem
          
          if (!toggle) return;
          
          // Make the entire menu item clickable (avoid duplicate listeners)
          if (!menuItem.hasAttribute('data-click-enhanced')) {
            menuItem.setAttribute('data-click-enhanced', 'true');
            menuItem.addEventListener('click', function(e) {
              // Don't prevent default if clicking on the toggle button itself
              if (e.target === toggle) return;
              e.preventDefault();
              toggle.click();
            });
          }
        });
      }
      
      function autoExpandCardsMenu() {
        const currentUrl = window.location.pathname;
        const urlParts = currentUrl.split('/');
        const lastPart = urlParts[urlParts.length - 1];
        
        const shouldAutoExpand = (
          lastPart.includes('-card') || 
          lastPart === 'card-packs' ||
          currentUrl.includes('/collections/') && (
            currentUrl.includes('cards') || 
            currentUrl.includes('card-packs')
          )
        );
        
        if (!shouldAutoExpand) return;
        
        // Find cards menu more flexibly - check the link href instead of text content
        const cardsMenuItem = Array.from(document.querySelectorAll('.offcanvas__menu_item[data-has-submenu]'))
          .find(item => {
            const href = item.getAttribute('href') || '';
            return href.includes('card');
          });

        if (cardsMenuItem) {
          const parentLi = cardsMenuItem.closest('.offcanvas__menu_li');
          const toggle = cardsMenuItem.querySelector('.offcanvas__sub_menu_toggle');
          const submenu = parentLi.querySelector('.offcanvas__sub_menu');
          
          if (toggle && submenu && !parentLi.classList.contains('active')) {
            // Set the expanded state directly without triggering transitions
            toggle.classList.add("active");
            parentLi.classList.add("active");
            toggle.innerHTML = "−"; // Set to minus symbol
            
            // Add the auto-opened class to disable transitions
            submenu.classList.add("auto-opened");
            submenu.style.display = "block";
            
            // Close other menus (also without transitions)
            getSiblings(parentLi).forEach(function (item) {
              item.classList.remove("active");
              const otherSubmenu = item.querySelector('.offcanvas__sub_menu');
              if (otherSubmenu) {
                otherSubmenu.style.display = "none";
                otherSubmenu.classList.remove("auto-opened");
              }
              const otherToggles = item.querySelectorAll('.offcanvas__menu_item .offcanvas__sub_menu_toggle');
              otherToggles.forEach(function(otherToggle) {
                otherToggle.innerHTML = "+";
                otherToggle.classList.remove("active");
              });
            });
          }
        }
      }
    };
    
    /* Mobile Menu Active */
    offcanvasHeader();
  }

  return header;
})();